import { APIActionType } from "../action-types/APIActionType";

const initialState = {
  lentNfts: [],
  rentedNfts: [],
  marketNfts: [],
  borrowedNfts: [],
  collectionWiseBorrowedNfts: [],
  profileNfts: [],
  collectionWiseProfileNfts: [],
  claimableNfts: [],
  scholarListNfts: [],
  users: [],
  connectedAccount: {},
  scholars: [],
  balance: 0,
  balanceInUsd: 0,
  totalCollections: 0,
  totalNfts: 0,
  holdings: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APIActionType.SET_LENT_NFTS: {
      return {
        ...state,
        lentNfts: [...action.payload],
      };
    }

    case APIActionType.SET_HOLDINGS: {
      return {
        ...state,
        holdings: [...action.payload],
      };
    }

    case APIActionType.SET_RENTED_NFTS: {
      return {
        ...state,
        rentedNfts: [...action.payload],
      };
    }

    case APIActionType.SET_MARKET_NFTS: {
      return {
        ...state,
        marketNfts: [...action.payload],
      };
    }

    case APIActionType.SET_BORROWED_NFTS: {
      return {
        ...state,
        borrowedNfts: [...action.payload],
      };
    }
    case APIActionType.SET_CW_BORROWED_NFTS: {
      return {
        ...state,
        collectionWiseBorrowedNfts: [...action.payload],
      };
    }

    case APIActionType.SET_PROFILE_NFTS: {
      const totalNfts = action.payload.length;
      const totalCollections = [
        ...new Set(action.payload.map((nft) => nft.nftAddress)),
      ].length;
      return {
        ...state,
        profileNfts: [...action.payload],
        totalNfts,
        totalCollections,
      };
    }

    case APIActionType.SET_CW_PROFILE_NFTS: {
      return {
        ...state,
        collectionWiseProfileNfts: [...action.payload],
      };
    }
    case APIActionType.SET_CLAIMABLE_NFTS: {
      return {
        ...state,
        claimableNfts: [...action.payload],
      };
    }
    case APIActionType.SET_SCHOLAR_LIST_NFTS: {
      return {
        ...state,
        scholarListNfts: [...action.payload],
      };
    }
    case APIActionType.SET_ALL_USER: {
      return {
        ...state,
        users: [...action.payload],
      };
    }

    case APIActionType.SET_SCHOLARS: {
      return {
        ...state,
        scholars: [...action.payload],
      };
    }

    case APIActionType.SET_CONNECTED_ACCOUNT: {
      return {
        ...state,
        connectedAccount: action.payload,
      };
    }

    case APIActionType.RESET_API_DATA:
      return initialState;

    case APIActionType.SET_USER_BALANCE: {
      return {
        ...state,
        balance: Number(action.payload.balance).toFixed(2),
        balanceInUsd: Number(action.payload.balanceInUsd).toFixed(2),
      };
    }

    default:
      return state;
  }
};

export default reducer;
